import React, { useMemo } from "react";
import { agruparResumenPorUsuario } from "./resumenAuditLog";

const AuditoriaResumenTable = ({ resumen, seleccion, onSeleccionar }) => {
  const grupos = useMemo(() => agruparResumenPorUsuario(resumen), [resumen]);
  const totalCantidad = useMemo(
    () =>
      (Array.isArray(resumen) ? resumen : []).reduce(
        (acc, row) => acc + (Number(row.cantidad) || 0),
        0
      ),
    [resumen]
  );

  if (!grupos.length) {
    return (
      <div className="no-results">
        No hay acciones de usuarios identificados en el periodo consultado.
      </div>
    );
  }

  return (
    <div className="table-container auditoria-resumen-wrap">
      <table className="cierre-turno-table auditoria-resumen-table">
        <thead>
          <tr>
            <th>Usuario</th>
            <th>Acción</th>
            <th>Cantidad</th>
          </tr>
        </thead>
        <tbody>
          {grupos.map((grupo, grupoIdx) =>
            grupo.filas.map((fila, filaIdx) => {
              const activa =
                seleccion &&
                seleccion.usuario === grupo.usuario &&
                seleccion.accion === fila.accion;
              const esPrimera = filaIdx === 0;
              const esUltima = filaIdx === grupo.filas.length - 1;

              return (
                <tr
                  key={`${grupo.usuario}|${fila.accion}`}
                  className={[
                    "auditoria-resumen-row",
                    activa ? "auditoria-resumen-row--activa" : "",
                    esPrimera ? "auditoria-resumen-row--grupo-inicio" : "",
                    esUltima ? "auditoria-resumen-row--grupo-fin" : "",
                    grupoIdx % 2 === 1 ? "auditoria-resumen-row--alt" : "",
                  ]
                    .filter(Boolean)
                    .join(" ")}
                  onClick={() =>
                    onSeleccionar({
                      usuario: grupo.usuario,
                      accion: fila.accion,
                      cantidad: fila.cantidad,
                    })
                  }
                  title="Ver detalle de estos registros"
                >
                  {esPrimera ? (
                    <td
                      className="auditoria-usuario-cell"
                      rowSpan={grupo.filas.length}
                    >
                      {grupo.usuario}
                    </td>
                  ) : null}
                  <td>{fila.accion}</td>
                  <td className="auditoria-cantidad">{fila.cantidad}</td>
                </tr>
              );
            })
          )}
        </tbody>
        <tfoot>
          <tr className="auditoria-resumen-total">
            <td colSpan={2}>Total</td>
            <td className="auditoria-cantidad">{totalCantidad}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default AuditoriaResumenTable;
